import React from "react";

export default function MainTermsBox2({
  id,
  src,
  top,
  right,
  termsName,
  isSelect = false,
  setTermsIndex,
}) {
  return (
    <div
      id={id}
      style={{
        top: `${top}vh`,
        right: `${right}vh`,
      }}
      className={`absolute w-[6.1vh] h-[6.1vh] max-w-[65px] max-h-[63px] ${
        isSelect
          ? "rounded-[15px] bg-[#fec62b8e] scale-125"
          : "rounded-[40px] bg-[#e5e5e5a4]"
      }   flex items-center justify-center cursor-pointer p-[8px] `}
      onClick={(e)=>{
        setTermsIndex(parseInt(e.target.id))
      }}
    >
      {isSelect && (
        <span
          className={`scale-75 absolute font-font_primary_A text-[16px] font-medium text-[#000000] bottom-[-30px] resize-none whitespace-nowrap`}
        >
          {termsName}
        </span>
      )}

      <img
        id={id}
        src={src}
        className="w-[4.8vh] h-[4.8vh] max-w-[50px] max-h-[50px]"
      />
    </div>
  );
}
